<div class="section">
  <div class="page-header">
    <h2 class="heading">ハイパフォーマー商談レコメンド設定</h2>
  </div>
  <div class="checkbox-wrapper">
    <mat-checkbox
      [checked]="useRoleModelRecommendation"
      [disabled]="busy || recommendationLoadFailed"
      (change)="onUseRoleModelRecommendationChange($event)"
      >ハイパフォーマー商談レコメンド機能を有効にする</mat-checkbox
    >
    @if (recommendationLoadFailed) {
      <p class="selection-error" role="alert">
        設定の読み込みに失敗しました。画面を再読み込みしてください
      </p>
    }
    <div class="caption">
      <p>
        ハイパフォーマー商談レコメンドを有効にすると、キーアクションのスコアに基づき、<br />アセスメント結果画面にお手本となる他ユーザーのアセスメント結果画面へのリンクが表示されます。
      </p>
    </div>
    @if (showSelectionSection) {
      <fieldset
        class="role-model-selection"
        [class.disabled]="!useRoleModelRecommendation"
        [disabled]="selectionDisabled"
        [attr.aria-busy]="busy"
      >
        <legend>ロールモデル商談の選出条件（スキルマップ別）</legend>
        <div class="caption">
          <p>
            スキルマップごとに、ロールモデル商談として表示するアセスメントをタグで絞り込めます。設定しないスキルマップでは、従来どおりタグを考慮せずに選びます。
          </p>
          <p>
            条件を設定すると、該当する商談を持たないメンバーはロールモデルの候補から外れるため、表示されるロールモデルが減ることがあります。
          </p>
        </div>
        @if (
          !useRoleModelRecommendation &&
          !recommendationLoadFailed &&
          !recommendationLoading
        ) {
          <p class="caption">
            ハイパフォーマー商談レコメンド機能を有効にすると設定できます
          </p>
        }
        @if (roleModelSelectionLoadFailed) {
          <p class="selection-error" role="alert">
            選出条件の読み込みに失敗しました
          </p>
        } @else if (roleModelSelectionLoading || recommendationLoading) {
          <p class="caption" role="status">選出条件を読み込んでいます…</p>
        } @else {
          @for (row of roleModelSelectionRows; track row.skillMapId) {
            <div class="role-model-selection-row">
              <div class="selection-summary">
                <span class="skill-map-name">{{ row.skillMapName }}</span>
                <span class="caption">{{ row.tagNames.join(', ') }}</span>
                <span>{{
                  row.matchMode === TagMatchMode.Any
                    ? 'いずれかを含む'
                    : 'すべてを含む'
                }}</span>
              </div>
              <div class="selection-actions">
                @if (row.canEdit) {
                  <button
                    rectangle
                    type="button"
                    variant="secondary"
                    class="selection-edit"
                    [disabled]="form != null"
                    (click)="editCondition(row)"
                  >
                    編集
                  </button>
                }
                <button
                  rectangle
                  type="button"
                  variant="secondary"
                  class="selection-delete"
                  (click)="deleteRoleModelSelectionSetting(row)"
                >
                  解除
                </button>
              </div>
              @if (row.hasInvalidTags) {
                <p class="selection-error">
                  {{
                    row.canEdit
                      ? '無効化されたタグが含まれています。編集して外してください'
                      : '無効化されたタグが含まれています。解除してください'
                  }}
                </p>
              }
            </div>
          } @empty {
            <p class="caption selection-empty">条件は設定されていません</p>
          }
          @if (tagMasters.length > 0) {
            <button
              rectangle
              type="button"
              variant="secondary"
              class="selection-add"
              [disabled]="form != null || availableSkillMaps.length === 0"
              (click)="addCondition()"
            >
              条件を追加
            </button>
          }
          @if (form; as editing) {
            <fieldset class="selection-form">
              <legend>
                {{
                  editing.mode === 'add'
                    ? '条件を追加'
                    : editing.skillMap.name + ' の条件を編集'
                }}
              </legend>
              <div class="selection-controls">
                @if (editing.mode === 'add') {
                  <app-select
                    ariaLabel="選出条件のスキルマップ"
                    [options]="availableSkillMaps"
                    [selectedOption]="editing.skillMap"
                    [disabled]="selectionDisabled"
                    (selectedOptionChange)="onSkillMapChange($event)"
                  />
                } @else {
                  <span class="skill-map-name">{{
                    editing.skillMap.name
                  }}</span>
                }
                <fieldset
                  class="tag-selection"
                  [disabled]="editing.skillMap.id === ''"
                >
                  <app-multiple-select
                    fieldName="タグ："
                    ariaLabel="ロールモデル商談の選出条件タグ"
                    [items]="editing.items"
                    [matchOptions]="tagMatchOptions"
                    [matchMode]="editing.matchMode"
                    (changeSelected)="onRoleModelTagsChange($event)"
                    (changeMatchMode)="onRoleModelMatchModeChange($event)"
                  />
                </fieldset>
              </div>
              @if (hasInvalidTags) {
                <div class="invalid-tag-warning">
                  <p class="selection-error">
                    無効化されたタグが含まれています。保存するには外してください
                  </p>
                  <button
                    rectangle
                    type="button"
                    variant="secondary"
                    class="remove-invalid-tags"
                    (click)="removeInvalidRoleModelTags()"
                  >
                    無効化されたタグを外す
                  </button>
                </div>
              }
              <div class="selection-actions">
                <button
                  rectangle
                  type="button"
                  class="selection-save"
                  [disabled]="!canSave"
                  (click)="saveRoleModelSelectionSetting()"
                >
                  保存
                </button>
                <button
                  rectangle
                  type="button"
                  variant="secondary"
                  class="selection-cancel"
                  (click)="cancelEditing()"
                >
                  キャンセル
                </button>
              </div>
            </fieldset>
          }
        }
      </fieldset>
    }
  </div>
</div>
